import React from 'react'
import useEventsManager from './use-events-manager'

export default function useOnEvent (name, callback, dependencies = []) {
  const manager = useEventsManager()

  React.useEffect(() => {
    const disposer = manager.onEvent(name, callback)

    return () => {
      disposer()
    }
  }, [name, ...dependencies])
}
